module.exports = __webpack_public_path__ + "static/media/dashboard-bg.64d9f77c.png";